let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("93PBJ")).then(() => parcelRequire('joVo6'));